/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Wins_TitleInputs */

const en_wc_vs_wins_title = /** @type {(inputs: Wc_Vs_Wins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where WordCraft wins`)
};

/**
* | output |
* | --- |
* | "Where WordCraft wins" |
*
* @param {Wc_Vs_Wins_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_wins_title = /** @type {((inputs?: Wc_Vs_Wins_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Wins_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_wins_title(inputs)
});
export { wc_vs_wins_title as "wc.vs.wins_title" }